import type { MethodFieldRef, MethodFunctionField, MethodStyleField } from '@/lib/method-draft';

/**
 * The marks of Réglages > Méthode (analyste.md §4.4, issue #196), for the unit
 * tests, `e2e/tests/reglages-methode.spec.ts` and
 * `e2e/screenshots-reglages-methode.mjs` - the last two RECOPY them, since the e2e
 * suite does not compile the frontend.
 *
 * The head, the history and the boxes are the layer's and carry the `methode-`
 * prefix of `METHOD_WORDING` (`methode-entete`, `methode-enregistrer`,
 * `methode-historique-ouvrir`, `methode-boite-enregistrer`, `methode-tiroir`);
 * what is here is the tab's own.
 */
export const METHOD_IDS = {
  /** The sentence under the head: what each pass reads. */
  intro: 'methode-intro',
  /** The summary above the cards while the draft cannot become a version. */
  blocked: 'methode-bloquee',
  /** The section of the three functions, and each of its three cards (`data-function`). */
  functions: 'methode-fonctions',
  functionCard: 'methode-fonction',
  /** The section of the six styles, and each of its six cards (`data-noyau`). */
  styles: 'methode-styles',
  styleCard: 'methode-style',
  /** The footnote of the seed: « v1 : graine de #196, ... ». */
  seed: 'methode-graine',
  /** The sentence of a tab with no version to show (a vitrine before its first passage). */
  notBorn: 'methode-introuvable',
} as const;

/** The unaccented slug of each field, for its marks. */
const FIELD_SLUG: Readonly<Record<MethodFunctionField | MethodStyleField, string>> = {
  designates: 'designe',
  words: 'mots',
  name: 'nom',
  recognizes: 'reconnait',
  typicalWords: 'typiques',
};

/**
 * The mark of the control of one field - `methode-champ-S-designe`,
 * `methode-champ-SGP-nom` - and the prefix of its three companions: `-modifie`
 * (the tag), `-compteur` (the counter) and `-refus` (the refusal under it).
 */
export function methodFieldId(ref: MethodFieldRef): string {
  return `methode-champ-${ref.key}-${FIELD_SLUG[ref.field]}`;
}
